import { render, staticRenderFns } from "./SpaceDetails.vue?vue&type=template&id=078d3e09"
import script from "./SpaceDetails.vue?vue&type=script&lang=ts"
export * from "./SpaceDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports